import store from "../redux/store";
import {
  increaseLoadingCounter,
  decreaseLoadingCounter,
  setIsTokenExpired
} from "../redux/actions";
import { STORE_CODES } from "../constants";
import { IS_NZ } from "../constants"

async function request(endpoint, body = undefined, method = "POST") {
  store.dispatch(increaseLoadingCounter());

  try {
    const url = `${process.env.REACT_APP_MAGENTO_BASE}/index.php/rest/${IS_NZ ? STORE_CODES.sparkNZ : STORE_CODES.sparkAU}/V1/${endpoint}`;
    const response = await fetch(url, {
      method,
      body: body === undefined ? body : JSON.stringify(body),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${store.getState().authorization.token}`
      },
      credentials: "include"
    });
    const json = await response.json();

    // The way in which the expired token is handled is less optimal here.
    // It should be handled at a higher level (e.g. all network requests go through redux),
    // which requires heavy code refactoring
    if (
      !response.ok &&
      json.message === "Consumer is not authorized to access %resources"
    ) {
      store.dispatch(setIsTokenExpired(true));
    }

    return json;
  } finally {
    store.dispatch(decreaseLoadingCounter());
  }
}

export const magentoApi = {
  get(endpoint) {
    return request(endpoint, undefined, "GET");
  },

  post(endpoint, data) {
    return request(endpoint, data, "POST");
  }
};
